import articleSearchFragment from './articleSearch.fragment'
import productResultPageProductsFragment from './productResultPageProducts.fragment'
import searchResponseFacetsFragment from './searchResponseFacets.fragment'

const productResultPageGuts = /* GraphQL */ `
  fragment productResultPageGuts on ProductResultPageResponse {
    isFollow
    engineFitmentPageTitle
    isIndex
    should404
    redirectUrl
    misoId
    misoEngine
    isFacetResultPage
    isNoResultPage
    isHouseFallBack
    isSearchPage
    isSearchFacetResultPage
    qualifiedForSuggestedFacet
    suggestedFacetsApplied
    incompleteYmmPage
    currentPageLinkRequestJson
    currentPage
    canonicalUrl
    prevUrl
    nextUrl
    pageTitle
    displayTitle
    totalSearchResults
    initialSideBarFacetCount
    searchWithinUrl
    representativeImageUrl
    suggestedYmmFacets {
      id
      type
      value
    }
    attribution {
      phrased_query
      is_phrased_query
      ymm_inference
      part_type_inference
      is_ymm
      is_racetype
      is_transmission
      is_rear_axle
      is_engine
      is_platform
      is_brand
      is_new_engine
      search_query_word_count
      multiple_fitment_facets
      short_description_match_candidate
      house_brand_boost_candidate
      semantic_search_candidate
      ymm_suggestion_applied
      ymm_suggestion_candidate
      rules
    }
    sortOrders {
      title
      url
      isSelected
    }
    bottomPageLinks {
      title
      isLateralFacet
      links {
        text
        url
        noFollow
      }
    }
    searchSpelling {
      explaination
      correctedQuery
    }
    selectedFacetOptions {
      displayText
      facetType
      engineFacetType
      fitmentDetails {
        raceType
        make
        model
        year
        raceTypeId
        makeId
        modelId
        vehicleBaseId
      }
      engineFitmentDetails {
        engineManufacturerId
        engineMakeId
        engineSeriesId
        engineConfigurationId
        engineVersionId
        engineQualifierId
        engineDisplacementId
        engineCodeId
        engineCamshaftTypeId
        engineFuelSystemId
      }
      searchResponseFacetOptions {
        displayValue
        id
        hidden
        facetOptionIdentifier
        parentFacetIdentifiers
        facetOptionLink {
          url
          noFollow
        }
      }
    }
    instrumentation {
      bloomreachInitialPageLoad {
        search_term
        title
        cat_id
        cat
        ptype
      }
      metrics {
        searchProviderName
        searchProviderRequestJson
        searchProviderRequest {
          diversification {
            key
            value {
              minimum_distance
            }
          }
        }
        boostingTags
        boostingCampaigns {
          matchedTags
          matchedQueries
          name
          campaignJson
        }
        productCampaigns {
          matchedTags
          matchedQueries
          name
          boostedSkuDetails {
            skuBaseNumber
            productPageUrl
            imageLink
            displayTitle
          }
          appliedBoosting
        }
      }
      featureFlags {
        featureFlagName
        treatment
      }
    }
    metaDescription
    pageContent {
      html
      extendedHtml
      brandImageUrl
      bannerImageUrl
      isMakerPage
      makerContentMobileHeight
      makerContentTabletHeight
      makerContentDesktopHeight
    }
    ...articleSearchFragment
    ...productResultPageProductsFragment
    searchResponseFacets {
      ...searchResponseFacetsFragment
    }
    breadcrumb {
      displayText
      ordinality
      url
      searchResponseFacetOption {
        facetOptionLink {
          url
          noFollow
        }
      }
    }

    pageContent {
      html
      extendedHtml
      brandImageUrl
      bannerImageUrl
      css
      metaDescription
      isMakerPage
      makerContentMobileHeight
      makerContentTabletHeight
      makerContentDesktopHeight
    }
    campaign {
      campaignType
      htmlText
      assets {
        placement
        device
        rows {
          title
          scrollable
          sections {
            image
            desktopImage
            mobileImage
            imageAlt
            href
            targetBlank
            overlayText
            overlaySubText
            seoFollow
          }
        }
        cards {
          image
          imageAlt
          href
        }
      }
      campaignPositions {
        campaignPositions
        campaignGridPositions
        campaignCardPositions
      }
    }
    appliedPhrases {
      phrases {
        key
        value
      }
      sminetAddNewPhraseUrl
      sminetUrl
    }
    facetRuleTargets {
      id
      name
      inherit
      query
      isIndex
      isFollow
      diversification
    }
    facetRules {
      name
      targetId
      id
      ruleApplicationOrdinality
      displayPosition
      facetType
      facetTypeDisplayName
      engineFacetType
      isLocalAttribute
      isLocalAttributeValue
      type
      ids
      facetIds {
        key
        value
      }
      attributeName
      sminetUrl
      isFollow
      isFollowEntirePage
      isIndex
      canonicalUrl
    }
    sminetAddNewFacetRuleUrl
    productRecalls {
      searchRecallId
      sopSkuBase
      url
      query
      boostingPosition
      isEnabled
      sminetUrl
    }
    sminetAddProductRecallUrl
    misoOrderByConfig {
      withoutFitment {
        indexForUserSortOrdering
        misoOrderByRules {
          field
          order
        }
      }
      withYmm {
        indexForUserSortOrdering
        misoOrderByRules {
          field
          order
        }
      }
      withRaceType {
        indexForUserSortOrdering
        misoOrderByRules {
          field
          order
        }
      }
      withDriveline {
        indexForUserSortOrdering
        misoOrderByRules {
          field
          order
        }
      }
      withTransmission {
        indexForUserSortOrdering
        misoOrderByRules {
          field
          order
        }
      }
      withPlatform {
        indexForUserSortOrdering
        misoOrderByRules {
          field
          order
        }
      }
      withBrand {
        indexForUserSortOrdering
        misoOrderByRules {
          field
          order
        }
      }
      treatment
    }
    filteringRule {
      conditions {
        key
        value
        isNegated
      }
      operators
    }
  }

  ${articleSearchFragment}
  ${productResultPageProductsFragment}
  ${searchResponseFacetsFragment}
`

export default productResultPageGuts
